'use client';
import getLocal from '@/app/utils/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import DefaultStyle from 'lowcode/common/DefaultStyle';
import EditorLink from 'lowcode/components/EditorLink';
import moment from 'moment';
import { useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import styles from './index.module.scss';

export default function Content({ id, data, attr = {} }: any) {
    const { title, moreLink, moreText } = data;
    const [list, setList] = useState([]);
    const { locale } = getLocal();
    const getbloglist = async function () {
        const res = await fetch(`/api/getbloglist?locale=${locale}`);
        const data = await res.json();
        setList(data?.data || []);
    };
    useEffect(() => {
        getbloglist();
    }, []);
    return (
        <div
            className={`${styles.content} temp-hide GtmModuleData-section temp-${id}`}
            id={id}
            data-section-id="editor-ListNewsCardA"
            data-section-id2={id}
            data-section-classname=".ListNewsCard-title"
        >
            <DefaultStyle id={id} attr={attr} />
            <div className="ListNewsCard-title">{title}</div>
            <div className="ListNewsCard-list">
                {list?.map((item: any, index: number) => {
                    return (
                        <div key={index} className="ListNewsCard-item">
                            <EditorLink
                                className="ListNewsCard-item-in"
                                href={item.link}
                                dataLayer={{
                                    event_name: 'learn_more',
                                    page_name: item.title,
                                    list_name: title,
                                    button_name: 'none',
                                }}
                            >
                                <EcoImg className="ListNewsCard-img" pc={item.pc} h5={item.h5} isOpenLazy={true} />
                                <div className="ListNewsCard-msgs">
                                    <div
                                        className="ListNewsCard-item-title"
                                        style={{
                                            color: item.theme,
                                        }}
                                    >
                                        {item.title}
                                    </div>
                                    <div
                                        className="ListNewsCard-item-desc"
                                        dangerouslySetInnerHTML={{
                                            __html: sanitizeHtml(item?.desc, {
                                                allowedTags: [''],
                                            }),
                                        }}
                                    ></div>
                                    <div className="ListNewsCard-item-footer">
                                        <div className="ListNewsCard-item-logo">
                                            <EcoImg pc={'https://websiteoss.ecoflow.com/upload/image/1744339350834/logo.svg'} />
                                        </div>
                                        <div className="ListNewsCard-item-date">ECOFLOW {!!item.date && <>- {moment(item.date).format('YYYY-MM-DD')}</>}</div>
                                    </div>
                                </div>
                            </EditorLink>
                        </div>
                    );
                })}
            </div>
            {moreLink && moreText && (
                <EditorLink href={moreLink} className="ListNewsCard-btn">
                    {moreText}
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path
                            d="M5.05197 2.2605L9.0603 6.26883L5.05197 10.2772"
                            stroke="#3F68E0"
                            strokeWidth="1.05219"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </EditorLink>
            )}
        </div>
    );
}
